import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import LoginPage from "@/views/LoginPage.vue";
import HomePage from "@/views/HomePage.vue";
import MainLayout from "@/layout/MainLayout.vue";
import NotFoundPage from "@/views/NotFoundPage.vue";
import AdminLayout from "@/layout/AdminLayout.vue";
import AdminPanel from "@/views/AdminPanel.vue";
import ChangePassword from "@/views/ChangePassword.vue";
import UsersPanel from "@/views/UsersPanel.vue";
import AppsPanel from "@/views/AppsPanel.vue";

const routes = [
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
    meta: { title: "Iniciar Sesión" },
  },
  {
    path: "/",
    name: "MainLayout",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "HomePage",
        component: HomePage,
        meta: { requiresAuth: true, title: "Inicio" },
      }
    ],
  },
  {
    path: "/admin-panel",
    name: "AdminLayout",
    component: AdminLayout,
    children: [
      {
        path: "",
        name: "AdminPanel",
        component: AdminPanel,
        meta: { requiresAuth: true, title: "Panel de Administración" },
      },
      {
        path: "users-panel",
        name: "UsersPanel",
        component: UsersPanel,
        meta: { requiresAuth: true, title: "Panel de Usuarios" },
      },
      {
        path: "apps-panel",
        name: "AppsPanel",
        component: AppsPanel,
        meta: { requiresAuth: true, title: "Panel de Aplicaciones" },
      },
    ]
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
    meta: { requiresAuth: true, title: "Cambiar Contraseña" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFoundPage,
    meta: { title: "Página no encontrada" },
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Lógica de protección de rutas
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  if (to.meta.requiresAuth && !authStore.token) {
    next("/login");
  } else if (
    to.meta.requiredPermission &&
    !authStore.permisos.includes(to.meta.requiredPermission)
  ) {
    next("/login");
  } else {
    next();
  }
});

export default router;
